import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { CustomerViewAllTabsProps } from "./customer-view-all-tabs-props";
import { CustomTabPanelComponent } from "../../../common/components";
import CustomerViewDetails from "./customer-view-details/customer-view-details";
import CustomerViewAdditionalDetails from "./customer-view-additional-details/customer-view-additional-details";
import CustomerViewTimeline from "./customer-view-timeline/customer-view-timeline";
import CustomerViewDetailsViewAttachmentInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-attachment-info/customer-view-details-view-attachment-info";
import CustomerViewDetailsViewProductInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-product-info/customer-view-details-view-product-info";
import CustomerViewDetailsViewOpenActivitiesInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-open-activities-info/customer-view-details-view-open-activities-info";
import CustomerViewDetailsViewClosedActivitiesInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-closed-activities-info/customer-view-details-view-closed-activities-info";
import CustomerViewDetailsViewInvitedMeetingsInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-invited-meetings-info/customer-view-details-view-invited-meetings-info";
import CustomerViewDetailsViewEmailInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-email-info/customer-view-details-view-email-info";
import CustomerViewDetailsViewCampaignsInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-campaigns-info/customer-view-details-view-campaigns-info";
import "./customer-view.scss";
import { useLogin } from "../../../common/hooks/useUser";
import CustomerViewDetailsViewLeadsInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-leads-info/campaign-view-details-view-leads-info";
import CustomerViewDetailsViewDocumentInfo from "./customer-view-details/customer-view-details-view/customer-view-details-view-documents-info/customer-view-details-view-document-info";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// … rest of your imports remain the SAME…

const CustomerViewDetailsAllTabsResponsive: React.FC<CustomerViewAllTabsProps> = ({
  customerDetails,
  selectedCustomerId,
  setLoading,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  setUploadedImage,
  uploadedImageFile,
  setUploadedImageFile,
  setRemoveImage,
  removeImage,
  fetchCustomerDetails,
  leadId,
  onCustomerNameUpdate,
  resetImageUpload,
  setAlertMessage,
  setAlertType,
  setAlertOpen,
  viewAddFullInfoOpen,
  setViewAddFullInfoOpen,
  disableCustomerStatus,
  permissions,
  setCrumbMappingOption,
  setViewTaskvalue,
  setViewMeetingvalue,
  setViewCallValue,
  isMobile,
}) => {
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [indexValue, setIndexValue] = React.useState(0);
  const [updatedDate, setUpdatedDate] = useState<string | undefined>();
  const [disableEdit, setDisableEdit] = useState<boolean>(false);
  const { tenantDetails } = useLogin();
   const [selectedAccordion, setSelectedAccordion] = useState(null);

  const handleMainTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setIndexValue(newValue);
    setViewFullInfoOpen(false);
    setViewAddFullInfoOpen(false);
  };

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  const handleFormSubmitError = (from?: any) => {
    if ("additionalDetails" === from) {
      setViewAddFullInfoOpen(true);
      setIndexValue(1);
      setAlertMessage(
        "Validation error in additional details tab. Please check the fields."
      );
      setAlertType("error");
      setAlertOpen(true);
    } else {
      setViewFullInfoOpen(true);
      setIndexValue(0);
      setAlertMessage(
        "Validation error in details tab. Please check the fields."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    if (
      tenantDetails?.tenantType === "SuperTenant" &&
      customerDetails?.assigned_to &&
      customerDetails?.lead_status !== "Closed-Lost"
    ) {
      setDisableEdit(true);
    }
    else if (tenantDetails?.tenantType === "Tenant"
      && customerDetails?.lead_status === "Closed-Lost" 
      && customerDetails?.lead_source === "AFP"
    ) {
      setDisableEdit(true);
    }
    else setDisableEdit(false);
  }, [customerDetails]);

  const handleAccordionChange = (panel:any) => (even:any, isExpanded:any) => {
    setSelectedAccordion(isExpanded ? panel : false);
  };
  
  return (
    <div className="leads-view-all-tabs">
      {/* Detailed View */}
      <Box>
        {/* 1. Primary details */}
        <Accordion expanded={selectedAccordion === 'panel1'}
          onChange={handleAccordionChange('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            Primary Details
          </AccordionSummary>
          <AccordionDetails className="no-padding-accordion-details">
            <CustomerViewDetails
            customerDetails={customerDetails}
            selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            viewFullInfoOpen={viewFullInfoOpen}
            setViewFullInfoOpen={setViewFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchCustomerDetails={fetchCustomerDetails}
            onCustomerNameUpdate={onCustomerNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            disableCustomerStatus={disableCustomerStatus}
            permissions={permissions}
            isMobile={isMobile}
          />
          </AccordionDetails>
        </Accordion>

        {/* 2. Additional details */}
        <Accordion expanded={selectedAccordion === 'panel2'}
          onChange={handleAccordionChange('panel2')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            Additional Details
          </AccordionSummary>
          <AccordionDetails className="no-padding-accordion-details">
            <CustomerViewAdditionalDetails
            customerDetails={customerDetails}
            selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            viewFullInfoOpen={viewAddFullInfoOpen}
            setViewFullInfoOpen={setViewAddFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchCustomerDetails={fetchCustomerDetails}
            onCustomerNameUpdate={onCustomerNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            permissions={permissions}
            isMobile={isMobile}
          />
          </AccordionDetails>
        </Accordion>

        {/* 3. Attachments */}
        <Accordion expanded={selectedAccordion === 'panel3'}
          onChange={handleAccordionChange('panel3')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Attachments
          </AccordionSummary>
          <AccordionDetails>
            <CustomerViewDetailsViewAttachmentInfo
            setLoading={setLoading}
            customerId={leadId}
            disableEdit={disableEdit}
            permissions={permissions}
          />
          </AccordionDetails>
        </Accordion>
         {/* 4. Documents */}
        <Accordion expanded={selectedAccordion === 'panel4'}
          onChange={handleAccordionChange('panel4')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Documents
          </AccordionSummary>
          <AccordionDetails>
            <CustomerViewDetailsViewDocumentInfo
            setLoading={setLoading}
            leadId={leadId}
            disableEdit={disableEdit}
            permissions={permissions}
          />
          </AccordionDetails>
        </Accordion>
        {/* 5. Leads */}
        <Accordion expanded={selectedAccordion === 'panel5'}
          onChange={handleAccordionChange('panel5')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Leads
          </AccordionSummary>
          <AccordionDetails>
            <CustomerViewDetailsViewLeadsInfo
           permissions={permissions}
           selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            />
          </AccordionDetails>
        </Accordion>

        {/* 5. Activities */}
        <Accordion expanded={selectedAccordion === 'panel6'}
          onChange={handleAccordionChange('panel6')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Activities
          </AccordionSummary>
          <AccordionDetails>
             <CustomerViewDetailsViewOpenActivitiesInfo
            // disableEdit={disableEdit || !permissions?.canWrite}
            customerDetails={customerDetails}
            setViewTaskvalue={setViewTaskvalue}
            setCrumbMappingOption={setCrumbMappingOption}
            permissions={permissions}
            setViewMeetingvalue={setViewMeetingvalue}
            allLeadData={selectedCustomerId}
            setViewCallValue={setViewCallValue}
          />
          </AccordionDetails>
        </Accordion>

        {/* 5. Emails */}
        <Accordion expanded={selectedAccordion === 'panel7'}
          onChange={handleAccordionChange('panel7')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Communications
          </AccordionSummary>
          <AccordionDetails>
            <CustomerViewDetailsViewEmailInfo
            disableEdit={disableEdit || !permissions?.canWrite}
            customerDetails={customerDetails}
          />
          </AccordionDetails>
        </Accordion>

        {/* 6. Campaigns */}
        <Accordion expanded={selectedAccordion === 'panel8'}
          onChange={handleAccordionChange('panel8')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Campaigns
          </AccordionSummary>
          <AccordionDetails>
            <CustomerViewDetailsViewCampaignsInfo
            allCustomerData={selectedCustomerId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            disableEdit={disableEdit || !permissions?.canWrite}
          />
          </AccordionDetails>
        </Accordion>

        {/* 7. Timeline */}
        <Accordion expanded={selectedAccordion === 'panel9'}
          onChange={handleAccordionChange('panel9')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Timeline
          </AccordionSummary>
          <AccordionDetails>
            <CustomerViewTimeline
            selectedCustomerId={selectedCustomerId}
            setLoading={setLoading}
            setUpdatedDate={setUpdatedDate}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
          </AccordionDetails>
        </Accordion>

      </Box>
    </div>
  );
};

export default CustomerViewDetailsAllTabsResponsive;
